const style = (sx) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 'var(--p-space-200)',
    backgroundColor: 'white',
    py: '0px !important',
    px: sx.px,
    '&.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      color: '#8A8A8A',
      '& .MuiOutlinedInput-notchedOutline': { border: '0px' },
    },
  },
  '& .MuiFilledInput-root': {
    borderRadius: 'var(--p-space-200)',
    py: '0px !important',
    px: sx.px,
  },
  '& .MuiInputBase-root': {
    mt: sx.mt,
    height: sx.height,
  },
  '& .MuiInputBase-input': {
    padding: 'var(--p-space-150) var(--p-space-300) !important',
    fontSize: '0.875rem',
  },
  '& .MuiInputBase-multiline': {
    padding: '0px !important',
  },
});
const buttonStyle = () => ({
  borderRadius: 'var(--p-space-200)',
  height: '40px',
});
export const tableInputStyles = style({ height: '28px' });
export const tableIconInputStyles = style({ height: '28px', px: '14px' });
export const inputStyles = style({ mt: 'var(--p-space-100)' });
export const customInputStyles = (sx) => style(sx);

export const errorInputBgStyles = {
  '& .MuiOutlinedInput-root.Mui-error': {
    backgroundColor: 'var(--app-input-error-bg)',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--app-input-error-border)',
    },
  },
  '& .MuiFilledInput-root.Mui-error': {
    backgroundColor: 'var(--app-input-error-bg)',
    boxShadow: 'inset 0 0 0 1px var(--app-input-error-border)',
  },
};

export const largeButtonStyle = buttonStyle();

export const TOOLTIP_STYLES = {
  tooltip: {
    sx: {
      backgroundColor: '#FFFFFF',
      color: '#000000',
      boxShadow:
        '1px 0 0 0 rgba(0, 0, 0, 0.13) inset, -1px 0 0 0 rgba(0, 0, 0, 0.13) inset, 0 -1px 0 0 rgba(0, 0, 0, 0.17) inset, 0 1px 0 0 rgba(204, 204, 204, 0.50) inset, 0 4px 6px -2px rgba(26, 26, 26, 0.20)',
      fontSize: '13px',
      fontWeight: 500,
      display: 'flex',
      maxWidth: '218px',
      minWidth: 'auto',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '8px 12px 12px 12px',
      whiteSpace: 'pre-line',
      wordBreak: 'break-word',
      borderRadius: 'var(--p-border-radius-200)',
    },
  },
  arrow: {
    sx: {
      color: '#FFFFFF',
    },
  },
};
